// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9.34 4.54L5.1 8.78C4.52 9.36 4.52 10.31 5.1 10.9C5.69 11.48 6.64 11.48 7.22 10.9L11.46 6.66C12.64 5.48 12.64 3.59 11.46 2.41C10.29 1.24 8.39 1.24 7.22 2.41L2.98 6.66C1.22 8.41 1.22 11.26 2.98 13.02C4.74 14.78 7.59 14.78 9.34 13.02L13.8 8.57',
];
